
import { GET_POST_DATA_FAILURE, GET_POST_DATA_REQUEST, GET_POST_DATA_SUCCESS } from "./actionTypes";
import {POST_POST_DATA_REQUEST, POST_POST_DATA_SUCCESS, POST_POST_DATA_FAILURE } from "./actionTypes"

const initialState = {
    posts: [],
  isLoading: false,
  isError: false,
  errorMessage:""
};

const postReducer = (state = initialState, {type, payload}) => {
  switch(type){
    case GET_POST_DATA_REQUEST:
      return {...state, isLoading:true}
    case GET_POST_DATA_SUCCESS:
      return {...state, isLoading:false, posts:payload, isError:false}
    case GET_POST_DATA_FAILURE:
      return {...state, isError:true, errorMessage:payload}

      case POST_POST_DATA_REQUEST:
        return {...state, isLoading: true}; 
        case POST_POST_DATA_SUCCESS:
        return {...state, isLoading: false, posts:[...state.posts, payload]};
         case POST_POST_DATA_FAILURE:
        return {...state, isLoading: false, isError: true}; 

      default:
        return state
  }
};

export default postReducer;
